export default "__VITE_ASSET__bec5348a__"